import React from 'react';
import defaultImg from '../../img/backgrounds/si_50px.gif';
import socialImg from '../../img/backgrounds/si_50px-social.gif';

interface SpaceInvaderProps {
  id: string;
  clicked: Set<string>;
  onInvaderClick: (id: string) => void;
  variant?: 'default' | 'social';
  style?: React.CSSProperties;
  imgStyle?: React.CSSProperties;
  imgClassName?: string;
}

export const SpaceInvader = ({
  id,
  clicked,
  onInvaderClick,
  variant = 'default',
  style,
  imgStyle,
  imgClassName,
}: SpaceInvaderProps) => {
  const isClicked = clicked.has(id);
  const src = variant === 'social' ? socialImg : defaultImg;

  return (
    <div
      id={id}
      className='spaceinvader'
      onClick={() => !isClicked && onInvaderClick(id)}
      style={{
        ...style,
        opacity: isClicked ? 0 : 1,
        transition: 'opacity 0.2s ease-out',
        pointerEvents: isClicked ? 'none' : 'auto',
      }}
    >
      <img
        alt='Space Invader'
        className={imgClassName ?? 'spaceinvaderimg'}
        src={src}
        style={imgStyle}
      />
    </div>
  );
};
